// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"0fb5d952","119":"0fb5d952","133":"facffa8e","223":"facffa8e","288":"3bcb0543","397":"facffa8e","520":"d5e6577e","666":"0fb5d952","679":"e8af0c74","738":"53f8ac10","875":"facffa8e","920":"3e3e4d03","965":"53e2ea83"}[chunkId] + ".chunk.css";
};